// firebase.ts
import { Capacitor } from '@capacitor/core'
import { firebaseConfig } from './firebaseConfig'
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'

const initializeFirebase = async () => {
  if (
    import.meta.env.VITE_ENABLED_THIRD_PARTY_TRACKING === 'true' &&
    Capacitor.isNativePlatform() === false
  ) {
    FirebaseAnalytics.initializeFirebase(firebaseConfig)
  }
}

export { initializeFirebase }
